import { render } from "./HeaderBar.vue?vue&type=template&id=dae48bf6&ts=true"
import script from "./HeaderBar.vue?vue&type=script&lang=ts"
export * from "./HeaderBar.vue?vue&type=script&lang=ts"

import "./HeaderBar.vue?vue&type=style&index=0&id=dae48bf6&lang=css"

import exportComponent from "/home/brix/jenkins/workspace/Projects/Afashub/Build/staging/afashub.staging.traffix.io_-_gz2nvet4_-_Vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__